import React, { useState, useEffect } from "react";

/*

* React FC
  
*/

function useWindowSize() {
  const isClient = typeof window === "object";
  function getSize() {

    return {
      width: isClient ? window.innerWidth : undefined
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    if (!isClient) {
      return false;
    }

    function handleResize() {

      setWindowSize(getSize());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  return windowSize;
}


const InputField = props => {


  const windowsize = useWindowSize();

  const { currentFieldValue, fieldValue, updateFieldValue } = props;
  const showError = () => {
    const { field, minVal, maxVal } = fieldValue;
    return (
      currentFieldValue[field] &&
      (currentFieldValue[field] < minVal || currentFieldValue[field] > maxVal)
    );
  };

  const getinputDivWidth = label => {
    if (label === "Year" || label === "Month") {
      return "10%";
    } else {
      if (windowsize.width <= 600) {
        return "100%";
      } else {
        return "30%";
      }
    }
  };

  return (
    <div
      className="flex-col spacer_sm inputDiv"
      style={{
        width: getinputDivWidth(fieldValue.label),
        minWidth:
          fieldValue.label === "Year" || fieldValue.label === "Month"
            ? "70px"
            : "180px",
        marginRight:
          (fieldValue.label === "Year" || fieldValue.label === "Month") &&
            windowsize.width <= 600
            ? "16px"
            : "0"
      }}
    >
      <label for={fieldValue.field} className="para-4 text-black inputLabel">
        {fieldValue.label}
      </label>
      <input
        className="para-3 bold rounded  inputFieldStyles"
        type="number"
        value={currentFieldValue[fieldValue.field]}
        onChange={updateFieldValue(fieldValue.field)}
        name={fieldValue.field}
        readOnly={fieldValue.readOnly}
        style={{
          background: fieldValue.readOnly ? "#f5f5f5" : "none",
          width: "100%"

        }}
      />
      {showError() === true && (
        <InvalidData min={fieldValue.minVal} max={fieldValue.maxVal} />
      )}
      <style jsx>{`
      .inputDiv{
        padding: 0 8px;
      }
      .inputFieldStyles{
        width:90%;
        box-sizing:border-box;
        border: 1px solid rgba(0, 0, 0, 0.1);
        padding: 8px;
        display: block;
      }
      .inputLabel{
        opacity:0.6;
      }
      `}</style>
    </div>
  );
};

/*

* React FC
* Invalid Data Component
  
*/

const InvalidData = ({ min, max }) => (
  <span style={{ color: "red" }}>
    Please enter a valid amount.
    {min && <span> Minimum: {min} </span>}
    {max && <span>Maximum: {max} </span>}
  </span>
);

export default InputField;
